import { render, staticRenderFns } from "./EditCustomerAccountModal.vue?vue&type=template&id=58442f01&scoped=true&"
import script from "./EditCustomerAccountModal.vue?vue&type=script&lang=js&"
export * from "./EditCustomerAccountModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58442f01",
  null
  
)

export default component.exports